import { Chip, CircularProgress } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function rowCount(output: string | undefined): string {
  if (output === undefined) return "done";
  const trimmed = output.trim();
  if (trimmed.startsWith("[")) {
    try {
      const arr = JSON.parse(trimmed);
      if (Array.isArray(arr))
        return `${arr.length} row${arr.length === 1 ? "" : "s"}`;
    } catch {
      /* fall through */
    }
  }
  return "done";
}

interface Props {
  status: string;
  output: string | undefined;
}

function StatusChip({ status, output }: Props) {
  switch (status) {
    case "running":
      return (
        <Chip
          size="small"
          variant="outlined"
          icon={<CircularProgress size={12} thickness={6} />}
          label="running"
          sx={{ height: 22 }}
        />
      );
    case "done":
      return (
        <Chip
          size="small"
          color="success"
          variant="outlined"
          icon={<CheckIcon sx={{ fontSize: 14 }} />}
          label={rowCount(output)}
          sx={{ height: 22 }}
        />
      );
    case "error":
      return (
        <Chip
          size="small"
          color="error"
          variant="outlined"
          icon={<ErrorOutlineIcon sx={{ fontSize: 14 }} />}
          label="error"
          sx={{ height: 22 }}
        />
      );
    case "interrupted":
      return (
        <Chip
          size="small"
          color="warning"
          variant="outlined"
          icon={<WarningAmberIcon sx={{ fontSize: 14 }} />}
          label="interrupted"
          sx={{ height: 22 }}
        />
      );
  }
}

export default StatusChip;
